import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { X, Flame, ArrowRight } from 'lucide-react';
import { fetchSettings } from '../api';

const DEFAULT_PROMO = {
  enabled: true,
  eyebrow: 'Test Our Service',
  amount: '2 Days',
  priceLine: 'for €39',
  description: 'Try our expert football tips before choosing a longer subscription.',
  ctaText: 'Start Now',
  ctaLink: '/contact',
};

export default function PromoPopup() {
  const [promo, setPromo] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try { const s = await fetchSettings(); if (mounted) setPromo(s.promo || DEFAULT_PROMO); }
      catch (e) { if (mounted) setPromo(DEFAULT_PROMO); }
    })();
    return () => { mounted = false; };
  }, []);

  useEffect(() => {
    if (!promo || promo.enabled === false) return;
    if (sessionStorage.getItem('bn_promo_closed') === '1') return;
    const t = setTimeout(() => setOpen(true), 1500);
    return () => clearTimeout(t);
  }, [promo]);

  const close = () => {
    setOpen(false);
    sessionStorage.setItem('bn_promo_closed', '1');
  };

  if (!open || !promo || promo.enabled === false) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 z-[60] sm:left-auto sm:right-6 sm:w-[340px] animate-fade-up">
      <div className="relative overflow-hidden rounded-2xl border border-orange-500/40 bg-[#1b1712] p-5 shadow-2xl shadow-black/70">
        <div className="pointer-events-none absolute -right-8 -top-8 h-28 w-28 rounded-full bg-orange-500/20 blur-2xl" />
        <button
          onClick={close}
          aria-label="Close offer"
          className="absolute right-3 top-3 rounded-md p-1 text-neutral-400 transition-colors hover:bg-white/10 hover:text-white"
        >
          <X className="h-4 w-4" />
        </button>

        <div className="relative" data-testid="test-service-promo">
          {promo.eyebrow && (
            <span className="inline-flex items-center gap-1.5 rounded-full bg-orange-500 px-3 py-1 font-heading text-xs font-extrabold uppercase tracking-wide text-[#15120f]">
              <Flame className="h-3.5 w-3.5" /> {promo.eyebrow}
            </span>
          )}

          {promo.amount && (
            <div className="mt-3 flex items-end gap-2">
              <span className="font-heading text-4xl font-extrabold orange-text-gradient leading-none">{promo.amount}</span>
            </div>
          )}
          {promo.priceLine && <p className="mt-2 font-heading text-lg font-bold text-white">{promo.priceLine}</p>}

          {promo.description && (
            <p className="mt-2 text-sm leading-relaxed text-neutral-400">{promo.description}</p>
          )}

          <Link
            to={promo.ctaLink || '/contact'}
            onClick={close}
            className="btn-orange mt-4 flex w-full items-center justify-center gap-2 rounded-lg py-2.5 font-heading text-sm font-bold uppercase tracking-wide"
            data-testid="test-service-promo-cta"
          >
            {promo.ctaText || 'Start Now'} <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
      </div>
    </div>
  );
}
